module.exports = __webpack_public_path__ + "img/img_1.64632267.png";